import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard implements CanActivate {
    
  constructor(private dataService:DataService, private auth: AuthenticationService, private router:Router) {}
 
  async canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    // console.log('profile guard');
    let id = route.paramMap.get('profileId');

    const currentUser = await this.auth.getUser();
    // console.log('profile guard current user',currentUser);
    if(currentUser) {
      if(!currentUser.emailVerified){
        return this.router.createUrlTree(['action'],{ queryParams: { mode: 'sendEmailVerification'}});
      }
      else if(currentUser.role == 'admin'){
        // console.log('super admin');
        return true;
      }
      else if(currentUser.uid == id){
        // console.log('myself');
        return true;
      }
      else if(currentUser.uid !== id && currentUser.producers && currentUser.producers[id] && currentUser.producers[id].role == 'admin'){
        // console.log('admin in local user');
        return true;
      }
      else {
        // console.log('not an admin in local user');
        const managedProducer = await firstValueFrom(this.dataService.getMyProducer(id,currentUser.uid));
        // console.log('managed producer', managedProducer);
        if(managedProducer){
          this.auth.addToPermissions(id, 'producer','admin');
          return true;
        }
        else {
          return this.router.parseUrl(currentUser.role+'/'+currentUser.uid)
        }
      }
    }
    else{
      // this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
      return this.router.createUrlTree(['login'],{ queryParams: { returnUrl: state.url }});
    }
  }
}